// access localized strings by using the following lines of code

function i18n(props?: any) {
  const language = props ? props : "de";

  // TODO: get user language from store

  const localizedStrings: any = {
    // English language
    en: {

      reset_email_sent: "Email sent with a link to reset your password!",
      dropzone_dialog_title: "Drop file to upload",

      smtp_login_failed: "Wrong username or password",
      test_smtp:"TEST SMTP",
      email_config_updated_success:"Email Configuration Saved!",
      email_config_updated_error: "Error saving email configuration",
      planned: "Planned",
      last_product_pr : "Product run",
      last_product_br : "Batch run",

      product: "Product",
      time_based_report_description:
        "Reports are created at a time you specify.",
      flash_based_report_description:
        "Reports are created after a specified event and cover the period since the last event.",
      event_based_report_description:
        "Reports are created as soon as you click “create now” on a preconfigured, manual report. Your configuration can therefore be reused.",

      type_of_report: "Type of Report",
      internal_device_name: "Device Type",
      event: "Event",

      event_select_1: "after product change",
      event_select_2: "after batch change",

      event_listing_1: "for product chaange",
      event_listing_2: "for batch change",

      create_now: "Create Now",
      generate_configuration: "Generate configuration",
      new_equipment_btn: "NEW EQUIPMENT",
      date_from: "From Date",
      date_to: "To Date",
      start_time: "Start Time",
      end_time: "End Time",
      per_all: "all",
      per_site: "per Site",
      site: "Site",
      per_area: "per Area",
      time_based: "Time-based",
      event_based: "Event based",
      per_equipment: "per Equipment",
      password_reset_link: "Password Reset Link",
      landline_number_optional: "Landline number (optional)",
      edit_users: "Edit Users",
      backups: "Backups",
      back_to_dashboard: "Go to Dashboard",
      username: "Username",
      from: "From",
      active: "Active",
      inactive: "In-Active",
      pass_not_match: "Password Doesn't Match",
      area_not_found: "No Area Found",
      dashboard: "Dashboard",
      devices: "Devices",
      all_areas: "All Areas",
      report: "Report",
      all_reports: "All Reports",
      clock: "Clock",
      device_serial_number: "Device Serial Number : ",
      clear: "Clear",
      load: "Load",
      download_as_pdf: "Download as PDF",
      loading_document: "Loading Document…",
      inv_id: "Inventory-ID",

      eq_id: "Equipment-ID",
      eq_short_id: "Eq.ID",
      internername: "Equipment Name",
      type: "Type",
      admin: "Admin",
      equipment: "Equipment",
      something_went_wrong: "Something Went Wrong",
      postalcode: "Postcode",
      no_area_title: "You have not yet created an area",
      no_area_desc: "Now create an area and assign your equipment.",

      no_site_title: "You have not yet created a Site",
      no_site_desc: "Now create a plant and assign equipment to it.",

      creating_equipment: "Creating Equipment",

      back_to: "Back to ",

      street_house_number: "Street and House Number",
      additional_address: "Additional address (optional)",
      location: "Location",
      email_setting_title: "Email Configurations",
      load_event_in_time_frame: "Load events for the selected time frame",
      reset_time_frame: "Reset selected time frame",
      user_table_status: "status",
      user_table_Vorname: "First name",
      user_table_Nachname: "Last name",
      user_table_Benutzertyp: "User type",
      user_table_email: "E-mail address",
      address:"Address",
      eq_preview: "Equipment Preview",
      user_type: "User Types",
      email_configurations: "Email Configuration",

      site_example: "e.g : Site Oberpfaffenhofen",
      service_sticker: "Service-Sticker",
      mt_title: "Title",
      next_implementation: "Next Implementation",
      repetition: "Repetition",
      memory: "Memory",
      single_site: "Site",
      user: "User",
      set_password:"Set Password",
      sideNav_overview: "Overview",

      site_scope_title: "Sites",
      site_scope_description:
        "Here you manage the master data of a plant. After the plant has been created, you can create areas and assign equipment.",

      admin_search_placeholder: "Search users",

      areaname: "Area Name",

      area_order_number: "Order Number",
      predMt:
        "Switching cycles (discharge flap; rotary valves etc.)/drive elements (ball bearings etc.)",

      land_germany_name: "Germany",
      land_germany_value: "en",

      land_austria_name: "Austria",
      land_austria_value: "en",

      land_swiss_name: "Switzerland",
      land_swiss_value: "en",

      land_checkrepulic_name: "Czech Republic",
      land_checkrepublic_value: "en",

      land_poland_name: "Poland",
      land_poland_value: "en",

      create_site_title: "Create new site",
      edit_site_title: "Edit Site",

      days_list: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],

      dropdownNotificationType: [
        { title: "Malfunction", value: "0" },
        { title: "Abnormalities", value: "1" },
        { title: "Memos", value: "2" },
        { title: "Tasks", value: "3" },
        { title: "Internal Messages", value: "4" },
        { title: "Manufacturer Messages", value: "5" },
        // { title: "Planned Maintenances", value: "6" },
        // { title: "Maintenances", value: "7" },
      ],

      dropdownSolutionStatus: [
        { title: "Open", value: "0" },
        { title: "In Progress", value: "1" },
        { title: "Closed", value: "2" },
      ],

      scroll_to_top: "Scroll to Top",

      repition_monthly: "Monthly",
      repition_weekly: "Weekly",
      repition_daily: "Daily",

      next_report: "Next Report",

      exportsettings_site: "Site",
      exportsettings_area: "Area",
      exportsettings_equipment: "Equipment",

      equipment_scope_description:
        "Your equipment is your machines, devices and other things that you want to manage in Mesu Link.",

      area_scope_title: "Areas",
      area_scope_description:
        "Your factory can be divided into any number of areas to which your equipment is assigned.",

      area_delete: "area Delete",

      new_report_input_subheader_2_site:
        "A separate report is created for each plant.",
      new_report_input_subheader_2_area:
        "A separate report is created for each area.",
      new_report_input_subheader_2_equipment:
        "A separate report is created for each device.",
      new_report_input_subheader_2_all:
        "All plants, areas and devices are summarized in one report.",

      dashboard_messages: "Messages",

      Uhrzeit: "Time",
      sideNav_quality_management: "Quality Management",
      sideNav_manual_reports: "Manual Reports",
      manual: "manual",
      sideNav_geplante_reports: "Scheduled reports",

      sideNav_maintenance: "Maintenance",
      sideNav_maintenance_calender: "Maintenance calendar",
      sideNav_works_and_devices: "Works and devices",
      sideNav_product_backup: "Product Backup",
      sideNav_sites: "Sites and Equipments",
      sideNav_equipments: "Equipments",

      single_document: "Document",
      status: "Status",
      send: "Send",
      eemail: "Email",
      share_via_email: "share via email",
      share_email_btn: "SEND NOW",
      email_validation_error: "Please enter valid email address",
      delete_photo: "delete Photo",
      upload_new_photo: "Upload new image",

      landlinenummer: "Landline Number",
      single_area: "Area",

      product_number: "Product-Number",
      item_device_name: "Item device name",
      time_nkt: "Time",
      charge: "Charge",
      password_validation_error:
        "The current password is incorrect. (at least 8 characters, one capital letter and one lower case letter are mandatory)",
      two_fector_desc:
        "Please enter the six-digit code from your Google Authenticator app.",

      enter_code: "Enter the code",
      months: "months",
      overdue: "Overdue",
      feasible: "Feasible",
      carried_out: "Carried out",

      selected_devices: "Devices selected",
      time_period: "Period",

      product_count: "Product count",
      dash_stats_tooltip:
        "Number of eliminations (without testing) in 8 hours of production time compared to average number of eliminations in 8 hours (same product)",
      last: "last",
      last_t: "last",

      reject_detection: "Reject Detection",
      dashboard_proportion: "Proportion of rejects in the total volume",
      detector_test: "Successfully completed detector tests",

      dashboard_scope_header: "Dashboard",
      dashboard_scope_header_desc:
        "The dashboard gives you an overview of the status of your devices and current messages in your factory.",

      admin_scope_header: "Dashboard",
      admin_scope_header_desc:
        "Here you can create new users for MesuLink within your organization.",

      no_data: "No Data",
      cloud_backups: "Backups stored in the cloud",
      sort_desc: "absteigend sortiert",
      sort_asec: "sorted ascending",
      actions: "Actions",
      backup: "Backup",
      all_backups: "all Backups",
      alle_machine_parks: "All machine parks",
      all: "All",
      category: "Category",

      short_description: "Short Description",
      optional: "Optional",
      display_name: "Display Name",
      upload_attachment_title: "Select File",
      undefined: "Undefined",
      enter_search_term: "Enter Search...",
      profile: "Profile",
      header_search: "Search for customers, devices, ...",
      create_report: "Create report",
      reload_page: "reload page",

      browser_doesnot_support: "Your browser does not support the video tag.",

      are_you_sure_to_delete: "Are You Sure Want to Delete",
      delete_confirmation: "Delete Confirmation",
      answer: "answer",
      machine_detail: "Machine Detail",
      miantenance_calender_title: "Scheduled maintenance",
      miantenance_calender_select_1_label: "Machine park / section",
      miantenance_calender_select_2_label: "Implementation status",

      maintenance_calender_scope_header_desc:
        "This view helps you keep an eye on and plan recurring maintenance and inspections.",
      scope_new_rp_desc:
        "Record messages and events in your plants using planned reports and export the data as PDF/CSV.",

      scope_new_mn_rp_desc:
        "Create ready-made reports at the push of a button and easily export data about messages and events as PDF/CSV.",

      attach_log_file: "Attach device log file to this message",
      diagnose_information: "Diagnoseinformationen",
      diagnose_information_description:
        "To effectively identify problems, we need your device's diagnostic information.",
      reported: "Reported",
      create_title_helper_text: "e.g.: “Main spindle defective”",
      applicable_device: "Applicable device",
      message_description: "Description of the message",
      share_notification: "Share Notification",
      write_mail: "Please Write An Email Address",
      next_appointment: "Next Appointment",

      save_maintenance_task: "Create maintenance",
      desc_planned_aintenance: "Description of planned maintenance",
      heading_docs: "Documentation",
      create_maintenance_task: "Create new scheduled maintenance",
      create_maintenance_desc:
        "All users registered for a machine receive a reminder to carry out maintenance. You can manage the registered machines via the users' profile.",

      faq_description:
        "Here you will find frequently asked questions and answers about this device and can document your own questions and answers.",

      empty_state_history_title: "Device history",

      dnd_empty_title: "You have not uploaded any files in this category yet",
      dnd_empty_desc_1: "Upload one file. Tip: You can also upload multiple",
      dnd_empty_desc_2: "simultaneously via drag and drop.",


      empty_state_faq_heading: "Frequently asked questions and answers",
      empty_state_faq_title: "You have not yet stored any FAQs",
      empty_state_faq_description:
        "Click on the button to add a new question and answer about this machine.",

      empty_state_maintenance_heading: "Routine maintenance",
      empty_state_maintenance_title:
        "You have not scheduled any maintenance yet",
      empty_state_maintenance_description:
        "Routine maintenance is carried out at regular intervals.",

      empty_state_history_heading:
        "No reports have yet been registered for this device",
      empty_state_history_subheading:
        "Here you will find all malfunctions, maintenance, notes, etc. that have ever been documented in the system for this device.",
      tab_docs_manual: "Manuals",
      tab_messages_mo: "Messages",
      search_word: "Search Word",
      export_pdf: "Export PDF",
      filter_export: "Filter & Export",
      all_devices: "all Devices",
      deviceHistory: "Device History",
      more_stores: "more devices",
      your_devices: "Your Devices",
      type_plate: "Type Label",
      current_reports: "Current reports and planned maintenance",
      device_type: "Product/Article",
      devicetype: "Device Type",
      receivers_email: "Receivers email",
      backup_toast_text: "Backup was created and saved in Mesutronic Cloud.",
      backup_data_upload_loader: "Product data backup is created",
      backup_reload_tooltip: "Import backup",
      backup_download_tooltip: "Download backup",
      backup_delete_tooltip: "Delete backup",
      backup_upload_tooltip: "Upload manual backup to cloud",

      descending: "descending",
      ascending: "ascending",
      backup_title_1: "Backup of product parameters",
      backup_title_2: "Your devices",
      backup_scope_description:
        "Here you can create and restore backups of product parameters for your devices.",
      backup_search_placeholder: "Search device...",
      areas: "Areas",
      request_email: "Request email",
      assign_new_password: "assign new password",
      new_password_title: "Assign new password",
      new_password_detail:
        "Your password must be at least 8 characters long and contain one uppercase and one lowercase letter.",
      back_to_login: "Back to login",
      reset_password: "Reset Password",
      reset_password_detail:
        "You will receive an email to reset your password.",
      check_code: "Check Code",
      atleast_one_option: "Select atleast one option",
      new: "New",
      upload: "Upload",
      emptm_state_report_detail_title: "No reports have been created yet.",
      report_edit: "Edit Report",
      emptm_state_report_detail_description:
        "You can edit the scheduling of this report at any time.",
      rows_per_page: " entries per page",
      new_report_input_placeholder: "Title of the report",
      new_report_title_2_select_1_label: "Factories",
      new_report_title_2_select_2_label: "Areas",
      new_report_title_2_select_3_label: "Devices",

      new_report_title_3_select_1_label: "Cycle",
      new_report_title_3_select_2_label: "Day",
      new_report_title_3_select_3_label: "Time",

      new_report_title_4_select_1_label: "Export a report per",

      new_report_title_1: "New Report",
      new_report_title_2: "Selection criteria",
      new_report_title_3: "Creation time",
      new_report_title_4: "Output settings",
      new_report_footer_label: "Next report: %s O'clock",
      new_report_footer_button: "create report",
      new_report_checkbox_label: "Automatically send report via email",
      new_report_input_subheader: "e.g.: “Daily report for all devices",
      new_report_input_subheader_2:
        "A separate report data set is created for each plant.",
      scope_new_report_desc:
        "Using fine-grained selection options, you can determine which plants, areas or devices your future reports will include.",
      scope_new_report_plan: "Schedule new report",
      scope_edit_report_plan: "Edit Plan Report",

      reportsTitle: "Planned Reports",
      manualReportsTitle: "Manual Reports",

      reportsEmptyStateTitle: "You have not scheduled any reports yet",
      manualReportsEmptyStateTitle:
        "You have not yet configured any manual reports",
      manualReportsEmptystateDescription:
        "Configure your first manual report now so that you can easily create reports later at the push of a button.",

      reportsEmptystateDescription:
        "Plan your first report now so that you can document the messages from your devices in the long term.",
      reportsEmptyStateBtn: "Plan new Report",
      manualReportsEmptyStateBtn: "New Report",
      onlyMyReports: "only show my reports",
      login_header: "mesuLINK Login",
      footer_contact: "Contact",
      empty_docs_title: "You haven't uploaded any files yet",
      empty_dashboard_button: "Go to Profile",
      empty_dashboard_title: "Sie haben noch keine Maschinen abonniert",
      empty_docs_desc:
        "Upload a file and assign it to a category. Tip: You can also upload files using drag and drop.",

      create_noti_desc_title: "Description of the message",

      empty_dashboard_desc:
        "Um Maschinen zu abonnieren müssen Sie in Ihrem Userprofil im Bereich , Ihre Maschinen die für Sie relevanten Werke oder Maschinen Pools auswählen.",
      export_machine_details: "Export Machines Data",
      footer_data_protection: "data protection",
      footer_impressum: "imprint",
      equipment_serial_number: "Serial Number",
      save: "Save",
      no_notifications:
        "No new notifications. We’ll notifiy you as soon as there are new incidents.",
      sites: "Sites",
      counter_Type: "Counter Type",
      add_new_counter: "NEW",
      tab_counters: "Counters",
      streetnumber: "Street",
      interner: "Interner:",
      postalCode: "Postal Code",
      city: "City",
      firmName: "Firm Name",
      homePage: "Home Page",
      land: "Country",
      firm_details: "DETAILS ABOUT YOUR COMPANY",
      email: "Email address",
      password: "Password",
      forgot_password: "Forgot password?",
      loginHeading: "Log in",
      loginButton: "Log in",
      registration: "Registration",
      no_account: "You dont have any account?",
      register_for_free: "Register for free",
      searchplaceholder_tablet: "Search for machines, …",
      searchplaceholder_phone: "Search for machines, etc.",
      createnewissue: "Create new issue",
      update_notification: "Edit Notification",
      opennotifications: "Open Notifications",
      machineparks: "Machine parks",
      machinepark: "Machine park",
      all_machineparks: "All Machine parks",
      factorysections: "Factory sections",
      machinecategory: "Machine category",
      machinestatus: "Machine status",
      groupby: "Group by",
      timerange: "Time range",
      show_n_more: "Show %s more",
      show_more: "Show More",
      show_less: "Show less",
      // empty_notifications: 'There are currently no unresolved issues. Keep it up!',
      empty_notifications: "derzeit keine",
      notification_singular: "Notification",
      notification_plural: "Notifications",
      // avg_solutiontime: 'Ø Solution Time',
      avg_solutiontime: "MTTR",
      invalid_creds: "Invalid Credentials",
      incidents: "Incidents",
      statistics: "Statistics",
      overall_statistics: "Overall statistics",

      maintenance_dashboard_kpi_2_title: "Error messages",
      maintenance_dashboard_kpi_3_title: "Trouble-free operation",

      maintenance_dashboard_kpi_1_title1: "Devices out of order",
      maintenance_dashboard_kpi_1_title2: "due to errors (live)",

      maintenance_dashboard_kpi_2_title1: "Malfunctions (mesuLINK)",
      maintenance_dashboard_kpi_2_title2: "",

      maintenance_dashboard_kpi_3_title1: "Trouble-free operation",
      maintenance_dashboard_kpi_3_title2: "",

      maintenance_progress_title1: "Current switching cycles",
      maintenance_progress_title1_1: "Runtime of the conveyor (minutes)",
      maintenance_progress_title2: "Until Maintenance vs. Critical",

      new_notification: "New Notification",
      create_new_notification: "Create New Notification",
      create_notification: "Create Notification",

      save_notification: "Save",
      filter_sorting: "Filter & Sorting",
      filter: "Filter",
      sorting: "Sorting",
      unresolved: "unresolved",
      day: "day",
      days: "days",
      empty_machineparks:
        "No machine parks have been set up yet. Please contact the administrator.",
      undisturbed: "undisturbed",
      disturbed: "disturbed",
      tab_dashboard: "Dashboard",
      tab_machineparks: "Machine Parks",
      tab_device_messages: "Device messages",
      super_tab_clients: "Clients",
      super_tab_users: "Users",
      super_tab_brands: "Brands",
      super_tab_equipment_types: "Equipment Types",
      tab_notifications: "Notifications",
      manufacturer_serial_number: "Manufacturer Serial Number",
      heading_latest_notifications:
        "Latest Notifications & Scheduled Maintenance",
      go_to_machine_history: "Go to Machine History",
      heading_responsible: "Responsible",
      heading_manufacturer_service: "Manufacturer Service",
      heading_life_cycle: "Life Cycle",
      notificationtype: "Notification type",
      built_year: "Built year",
      empty_history: "The machine history does not show any notifications yet.",
      today: "Today",
      heading_documentation: "Documentation",
      file_powerpoint: "PowerPoint",
      file_excel: "Excel",
      file_word: "Word",
      file_email: "Email",
      file_word_macro: "Word (Macro)",
      file_odt: "ODT Document",
      file_ods: "ODS Spreadsheet",
      file_image: "Image",
      file_audio: "Audio",
      file_video: "Video",
      file_url: "Link",
      hasinternalattachment: "Interal Resources",
      hasmanufacturerattchment: "Manufacturer Resources",
      add_new_resource: "add new resource",
      add_ressource: "Add resource",
      upload_file: "Upload File",
      resource_vendor: "Classification",
      resource_type: "Type",
      resource_type_file: "File",
      resource_type_link: "Link",
      resource_type_photo: "Photo",
      resource_type_video: "Video",
      resource_url: "Link (URL)",
      change_file: "Change file",
      resource_name: "Resource title",
      resource_description: "Description (optional)",
      resource_language: "Language",
      resource_scope: "Scope",
      button_cancel: "cancel",
      button_yes: "Yes",
      button_no: "No",
      empty_resources: "No resources have been added to this machine yet.",
      button_done: "Done",
      select_multiple_n: "multiple (%s)",
      header_data: "Header Data",
      referred_to_machine: "Concerned Machine",
      notification_title: "Notification Title",
      helpertext_notification_title: 'e.g. "Main spindle faulty"',
      referred_to_assembly: "Concerned Assembly",
      date: "Date",
      time: "Time",
      problem_solution_status: "Problem solution status",
      notification_description: "Notification description",
      describe_notification: "Describe the notification…",
      add_photos_videos: "Add photos/videos",
      capture_photo: "Capture new photo",
      capture_video: "Capture new video",
      add_from_gallery: "Add from gallery",
      add_attachments: "Add attachments",
      enter_description: "Enter description…",
      change_attachments: "Change attachments",
      add_nameplate_photo: "Add nameplate photo",
      assign_equipment: "Assign Equipment",
      notification_sucessfully_created:
        "The notification was successfully created",
      discuss_notification: "Discuss notification",
      go_to_machine: "go to machine",
      notificationtype_from: "%notificationtype from %datetime",
      reported_by: "reported by",
      machine: "Machine",
      images: "Images",
      no_images_yet: "No images have been added to this notification yet.",
      attachments: "Attachments",
      edit_notification: "Edit Notification",
      notification_solved: "The notification has been successfully resolved.",
      close_notification_heading: "Close notification",
      close_notification_text:
        "Do you want to mark the notification as resolved and inform all participating instances about it?",
      settings: "Settings",
      chat_notifications: "Chat notifications",
      automatic_translation: "Automatic translation",
      activate: "activate",
      target_language: "Target language",
      involved_contacts_heading: "Involved Contacts",
      search_contacts: "Search contacts…",
      empty_discussion_contacts:
        "No contacts have been added to this discussion yet.",
      discussion_heading: "Discussion",
      error_chatroom_loading: "Failed to load chat room.",
      error_email_required: "Please enter your email address",
      error_email_format: "This is no valid email address",
      error_password_required: "Please enter your password",
      error_confirm_password: "Please enter your confirm password",
      confirm_password: "Confirm Password",
      set_password_btn:"Generate Password",
      error_password_wrong: "Email and password do not match",
      enter_message: "Enter message…",
      time_h: "h",
      alert_trash_changes_body: "Do you want to discard the changes you made?",
      button_save_changes: "Save changes",
      logout: "Logout",
      all_notificationtypes: "all notification types",
      notificationtype_malfunction: "Malfunction",
      notificationtype_abnormality: "Abnormality",
      notificationtype_memo: "Memo",
      notificationtype_task: "Task",
      notificationtype_internal_message: "Internal Message",
      notificationtype_manufacturer_message: "Manufacturer Message",
      notificationtype_planned_maintenance: "Planned Maintenance",
      notificationtype_maintenance: "Maintenance",
      avg_uptime: "Uptime",
      search_result: { sng: "Search Result", plr: "Search Results" },
      documents: "Documents",
      machines: "Machines",
      messages: "Messages",
      all_categories: "all categories",
      profile_settings: "Profile & Settings",
      add_machine_photo: "add machine photo",
      add_machine_typenameplate_photo: "machine typenameplate",
      add_user_photo: "add user photo",
      state_open: "open",
      state_closed: "closed",
      state_in_discussion: "in discussion",
      loading: "loading",
      access_denied: "Access Denied!",
      week: "week",
      month: "month",
      add_new_user: "Add New User",
      first_name: "First Name",
      last_name: "Last Name",
      user_list: "User List",
      please_fill_name: "Please fill name field.",
      backLink: "Back",
      create_new_area: "Create New Area",
      area_name: "Area name",
      area_id: "Area ID",
      e_g_area_1: "e.g. Area 1",
      e_g_area_id: "e.g. 1233",
      button_create_area: "Create area",
      manage_machine_parks: "Manage machine parks",
      manage_machine_park: "Manage machine park",
      create_machine: "Create Machine",
      manufacturer_name: "Manufacturer name",
      e_g_casing_machining: "e.g. Casing Machining",
      internal_id: "ID",
      e_g_internal_id: "e.g. 5214",
      invetory_id: "Inventory ID",
      e_g_inventory_id: "e.g. 1234",
      memo_field: "Memo",
      button_create_machine: "Create machine",
      create_equipment_pool: "Create Machine Park",
      equipment_pool_name: "Machine park name",
      equipment_pool_id: "Machine park ID",
      e_g_equipment_pool_id: "e.g. 1234",
      button_create_equipment_pool: "Create machine park",
      create_new_site: "Create New Site",
      site_name: "Site name",
      e_g_site_name: "e.g. Site 1",
      e_g_city: "e.g. Birmingham",
      site_zip: "Site ZIP Code",
      e_g_site_zip: "e.g. B1 1DA",
      street: "Street",
      e_g_street: "e.g. Bristol St.",
      house_number: "House Number",
      e_g_house_number: "e.g. 8",
      site_id: "Site ID",
      e_g_site_id: "e.g. 1234",
      button_create_site: "Create site",
      button_update_site: "Save Site",

      statistics_since_initial_operation: "Statistics since Initial Operation",
      manufacturer_website: "Manufacturer web site",
      click_or_dragdrop: "Click or drag-and-drop",
      download: "Download",
      page: "Page",
      ofPage: "of",
      previous: "Previous",
      next: "Next",
      file_title: "File Title",
      file_description: "File description",
      upload_internal_file: "Upload Internal File",
      show_qr_code: "show QR code",
      show_type_plate: "show type plate",
      show_more_info: "show more info",
      more_filter_sorting: "more Filters & Sorting",
      button_create_equipment: "Create equipment",
      typing: "typing…",
      write_a_message: "Write a message…",
      role: "Role",
      phone_number_mobile: "Cellphone Number (optional)",
      phone_number_landline: "Landline Number",
      info_notification_status:
        "You automatically receive status updates for the machines assigned to you.",
      your_machines: "Your Machines",
      min_n_characters: "Minimum 8 characters",
      button_create_account: "Create Account",
      load_older_notifications: "load older notifications",
      tab_sites: "Sites",
      tab_admin: "Admin Area",
      area: "Area",
      area_heading: "Area",
      open_menu: "Open menu",
      corporate_email: "Corporate email address",
      //create client labels
      create_client_name: "Client Name",
      create_client_billinginformation: "Billing Information",
      create_client_licenseinformation: "License Information",
      create_client_legalentityname: "Legal Entity Name",
      create_client_domain: "Domain",
      create_client_address: "Address",
      tab_overview: "Overview",
      register_now:"You can login now.",
      tab_discussion: "Discussion",
      heading_photos: "Photos",
      heading_videos: "Videos",
      button_upload_photo: "Upload photo",
      button_upload_video: "Upload video",
      button_upload_attachment: "Upload attachment",
      image_here: "Image here",
      none_uploaded: "None uploaded",
      empty_discussion: "So far, this issue was not discussed.",
      tab_history: "History",
      tab_documentation: "Documentation",
      tab_faq: "FAQ",
      tab_maintenance: "Maintenance",
      till_now: "Till now",
      create_site: "Create site",
      create_area: "Create area",
      all_sites: "all Sites",
      manufacturer: "Hersteller",
      internal_machine_name: "Internal Machine Name (optional)",
      heading_your_profile: "Your Profile",
      heading_safety: "Safety",
      photo: "Photo",
      add_solution: "Add Solution",
      workflow_step_desc: "Description",
      save_solution: "Save Solution",
      save_FAQ: "Save FAQ",
      workflow_title: "Workflow Title",
      no_workflow_title: "No Title",
      notification_solutions: "Notification Solutions",
      none_solution: "No Solution",
      edit_solution: "Edit Solution",
      internal_faqs: "Internal FAQs",
      manufacturer_faqs: "Manufacturer FAQs",
      required_field: "reuired field",
      update_faq: "EDIT",
      clear_faq: "DELETE",
      add_new_faq: "add new FAQ",
      add_faq: "Add FAQ",
      edit_faq: "Edit FAQ",
      faq_question: "Question",
      faq_answer: "Answer",
      maintenance: "Maintennance",
      new_maintenance: "New Maintenance",
      history_title: "Maschinenhistorie",
      maintenance_desc:
        "Routine maintenance is carried out at regular intervals.",
      history_description:
        "Here you will find all malfunctions, maintenance, notes, etc. that have ever been documented in the system for this machine.",
      counter_desc:
        "Counters help you register and keep an eye on important key figures such as operating hours.",
      new_maintenance_create: "Create New Maintenance",
      maintenance_title: "Maintenance Title",
      maintenance_title_helperText: 'e.g .: "Major Inspection"',
      noti_title_helpertext: "e.g.: “Removal unit defective“",
      maintenance_category: "Maintenance Category",
      maintenance_category_manage: "Manage Categories",
      maintenance_category_manage_title: "Manage Maintenance Categories",
      maintenance_category_new_title: "Create a new category",
      maintenance_category_title: "Category Name",
      maintenance_category_title_helperText: "e.g.: “ISO “45001",
      maintenance_category_btn_save: "Create a category",
      maintenance_category_delete: "Delete Category",
      maintenance_category_edit: "Edit Category",
      maintenance_date: "First Appointment",
      maintenance_repetition: "Cycle of Repetition",
      maintenance_reminder: "Reminder Before Appointment",
      maintenance_description: "Maintenance Description",
      maintenance_create_btn: "Create Maintenance",
      maintenance_update_btn: "Update Maintenance",
      maintenance_repetition_yearly: "Yearly",
      maintenance_repetition_month: "Month",
      maintenance_repetition_week: "week",
      maintenance_reminder_days: "days",
      maintenance_repetition_once: "One Time",
      maintenance_repetition_months: "Months",
      maintenance_reminder_Week: "Week",
      maintenance_reminder_Weeks: "Weeks",
      maintenance_reminder_month: "Month",
      maintenance_next_termine: "next appointment",
      maintenance_report: "Implementation Protocol",
      maintenance_report_empty:
        "There is still no record of a previous inspection.",
      maintenance_report_add_btn: "Create Report",
      protocol_executed: "Execution Date",
      protocol_title: "Create Report",
      protocol_comments: "Comments",
      protocol_title_pretext: "Reported on",
      protocol_title_posttext: "of",
      protocol_description: "Summary",
      protocol_update: "Update Protocol",
      menu_Instandhaltung: "Maintenance",
      menu_Instandhaltung_submenu: "Notifications",
      menu_Instandhaltung_submenu1: "Planned Maintenance",
      no_maintenancetask: "No Maintenancetask Available",
      edit_equipment: "Edit Equipment",
      edit: "Edit",
      delete: "Delete",
      nav_machinetype: "Machine Type",
      nav_customermachines: "Customer Machines",
      nav_customermachines_allmachine: "All Machines",
      nav_customermachines_analysis: "Analysis",
      nav_servicemanagement: "Service Management",
      nav_administration: "Administration",
      all_brands: "Alle Marken",
      brand: "Marken",

      create_equipment_type: "Create Equipment Type",
      update_equipment_type: "Update Equipment Type",
      delete_equipment_type: "Delete Equipment Type",
      create_brand: "Create Brand",
      update_brand: "Update Brand",
      delete_brand: "Delete Brand",
      create_equipment_class: "Create Equipment Class",
      update_equipment_class: "Update Equipment Class",
      delete_equipment_class: "Delete Equipment Class",
      customer_equipments: "Customer Equipments",
      customer_contact: "Customer Contact",

      history_filter_created: "Created",
      history_filter_closed: "abgeschlossen",
      history_filter_type: "Type",
      history_filter_status: "Status",
      history_filter_keyword: "Keyword",
      history_filter_reset: "Reset",
      history_filter_export: "Export Selection",
      history_filter_actions: "Actions",
      systemCreated: "System Created",
      allMachines: "All Equipments",
      allMachinePools: "All Equipment Pools",
      allSites: "All Sites",
      no_open_notification: "No Open Notication",

      new_area: "New Area ",
      create_an_area: "Create an area",
      create_area_helper_text: "e.g Housing Production",
      reports: "Reports",
      manualReportsSelectOptions: {
        lastBatch: { label: "Last Batch", value: "lastBatch" },
        currentBatch: { label: "Current Batch", value: "currentBatch" },
        currentd: { label: "Yesterday", value: "currentd" },
        last7d: {
          label: "Last 7 Days (default)",
          value: "last7d",
        },
        last14d: { label: "Last 14 Days", value: "last14d" },
        last30d: { label: "Last 30 Days", value: "last30d" },
        currentw: {
          label: "This Week (Monday to today)",
          value: "currentw",
        },
        last_week_monday_to_sunday: {
          label: "Last Week (Monday to Sunday)",
          value: "last1w",
        },
        currentm: { label: "This Month", value: "currentm" },
        last1m: { label: "Last Month", value: "last1m" },
        last3m: { label: "Last 3 Months", value: "last3m" },
        last6m: { label: "Last 6 Months", value: "last6m" },
        currenty: { label: "This Year", value: "currenty" },
        last1y: { label: "Last Year", value: "last1y" },
        customInterval: {
          label: "Custom (one-time report)",
          value: "customInterval",
        },
      },
    },

    // German language
    de: {

      reset_email_sent: "E-Mail mit Link zum Zurücksetzen des Passworts gesendet!",
      dropzone_dialog_title: "Datei fallen lassen, um hochzuladen",

      reports: "Reporte",
      smtp_login_failed: "Benutzername oder Passwort fehlerhaft",

      test_smtp:"Prüfen SMTP",
      dnd_empty_title: "Sie haben noch keine Dateien in dieser Kategorie hochgeladen",
      dnd_empty_desc_1: "Laden Sie eine Datei hoch. Tipp: Sie können auch mehrere Dateien",
      dnd_empty_desc_2: "gleichzeitig per Drag und Drop hochladen",

      email_config_updated_success:"E-Mail-Konfiguration gespeichert!",
      email_config_updated_error: "Fehler beim Speichern der E-Mail-Konfiguration",

      planned: "Geplant",
      last_product_pr : "Produktlauf",
      last_product_br : "Chagenlauf",

      product: "Produkt",
      time_based_report_description:
        "Reports werden zu einem von Ihnen festgelegten Zeitpunkt erstellt.",
      flash_based_report_description:
        "Reports werden nach einem festgelegten Ereignis erstellt und umfassen den Zeitraum seit dem letzten Ereignis.",
      event_based_report_description:
        "Reports werden erstellt, sobald Sie bei einem vorkonfigurierten, manuellen Report auf „jetzt erstellen“ klicken. Ihre Konfiguration kann somit wiederverwendet werden.",

      type_of_report: "Typ des Reports",
      event: "Ereignis",

      event_select_1: "nach Produktwechsel",
      event_select_2: "nach Chargenwechsel",
      
      event_listing_1: "zum Produktwechsel",
      event_listing_2: "zum Chargenwechsel",

      date_from: "Datum von",
      date_to: "Datum bis",
      create_now: "Jetzt Erstellen",
      generate_configuration: "Konfiguration generieren",
      per_all: "Alle",
      per_site: "pro Werk",
      site: "Werk",
      per_area: "pro Bereich",
      per_equipment: "pro Gerät",
      event_based: "Ereignis-basiert",
      password_reset_link: "Link zum Zurücksetzen des Passworts",
      landline_number_optional: "Festnetznummer (optional)",
      backups: "Backups",
      edit_users: "Edit Nutzer bearbeiten",
      last_t: "Zuletzt",
      back_to_dashboard: "Gehen Sie zum Dashboard",
      username: "Nutzername",
      from: "von",
      address:"Adresse",
      active: "Aktiv",
      inactive: "Inaktiv",
      pass_not_match: "Passwort stimmt nicht überein",
      area_not_found: "Kein Bereich gefunden",
      dashboard: "Armaturenbrett",
      devices: "Geräte",
      all_areas: "alle Bereiche",
      report: "Bericht",
      all_reports: "Alle Berichte",

      clock: "Uhr durch",
      device_serial_number: "Geräteserien-Nr.: ",
      clear: "Klar",
      load: "Laden",
      download_as_pdf: "Als PDF herunterladen",
      loading_document: "Dokument wird geladen…",
      inv_id: "Inventar-Nr",
      eq_id: "Equipment-Nr",
      eq_short_id: "Eq.Nr",
      internername: "Gerätename",
      devicetype: "Gerätetyp",
      type: "Typ",
      admin: "Administratorin",
      equipment: "EquipmentAusrüstung",
      something_went_wrong: "Etwas ist schief gelaufen",

      postalcode: "PLZ",
      location: "Ort",
      no_area_title: "Sie haben noch keinen Bereich angelegt",
      no_area_desc:
        "Erstellen Sie jetzt einen Bereich und ordnen Sie Ihr Equipment zu.",

      no_site_title: "Sie haben noch kein Werk angelegt",
      no_site_desc:
        "Legen Sie jetzt ein Werk an und ordnen diesem Equipment zu.",

      back_to: "zurück zu ",
      street_house_number: "Straße und Hausnummer",
      additional_address: "Adresszusatz (optional)",
      email_setting_title: "Email Konfigurationen",
      load_event_in_time_frame: "Events für den gewählten Zeitraum laden",
      reset_time_frame: "Zeitraum zurücksetzen",
      user_table_status: "status",
      user_table_Vorname: "Vorname",
      user_table_Nachname: "Nachname",
      user_table_Benutzertyp: "Benutzertyp",
      user_table_email: "E-Mail-Adresse",
      eq_preview: "Vorschau des Equipments",
      user_type: "Benutzertyps",
      email_configurations: "E-Mail-Konfigurationen",
      site_example: "z.B.: Werk Oberpfaffenhofen",
      mt_title: "Titel",
      rows: "Titel",
      next_implementation: "Nächste Durchführung",
      repetition: "Repetition",
      memory: "Erinnerung",

      sideNav_overview: "Struktur bearbeiten",

      site_scope_title: "Werke",
      site_scope_description:
        "Hier verwalten Sie die Stammdaten eines Werks. Nachdem das Werk erstellt wurde können Sie Bereiche erstellen und Equipment zuordnen.",

      admin_search_placeholder: "Benutzer durchsuchen",
      areaname: "Name des Bereichs",
      area_order_number: "Reihenfolge",
      predMt:
        "Schaltzyklen (Ausscheideklappe; Drehventile etc.)/Antriebselemente (Kugellager etc.)",

      admin_scope_header: "Administration",
      admin_scope_header_desc:
        "Hier können Sie neue Nutzer für MesuLink innerhalb lhrer Organisation anlegen.",

      create: "anlagen",

      sideNav_sites: "Werke und Geräte",

      land_germany_name: "Deutschland",
      land_germany_value: "de",

      land_austria_name: "Österreich",
      land_austria_value: "de",

      land_swiss_name: "Schweiz",
      land_swiss_value: "de",

      land_checkrepulic_name: "Tschechische Republik",
      land_checkrepublic_value: "de",

      land_poland_name: "Polen",
      land_poland_value: "de",
      new_equipment_btn: "NEUES EQUIPMENT",

      create_site_title: "Neues Werk anlegen",
      edit_site_title: "Werk bearbeiten",
      error_confirm_password: "Bitte geben Sie Ihr Bestätigungspasswort ein",

      dropdownNotificationType: [
        { title: "Störung", value: "0" },
        { title: "Auffälligkeit", value: "1" },
        { title: "Notiz", value: "2" },
        { title: "Aufgabe", value: "3" },
        { title: "Interne Mitteilung", value: "4" },
        { title: "Herstellermitteilung", value: "5" },
        // { title: "Geplante Wartung", value: "6" },
        // { title: "Wartung", value: "7" },
      ],

      dropdownSolutionStatus: [
        { title: "Offen", value: "0" },
        { title: "In Bearbeitung", value: "1" },
        { title: "Erledigt", value: "2" },
      ],

      days_list: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
      ],

      area_scope_title: "Bereiche",
      area_scope_description:
        "Ihr Werk kann in beliebig viele Bereiche eingeteilt werden, welchen Ihr Equipment zugewiesen ist.",

      scroll_to_top: "Nach oben scrollen",
      weekday_sunday: "Sonntag",
      weekday_monday: "Montag",
      weekday_tuesday: "Dienstag",
      weekday_wednesday: "Mittwoch",
      weekday_thursday: "Donnerstag",
      weekday_friday: "Freitag",
      weekday_saturday: "Samstag",

      repition_monthly: "Monatlich",
      repition_weekly: "Wöchentlich",
      repition_daily: "Täglich",

      exportsettings_site: "Werk",
      exportsettings_area: "Bereich",
      exportsettings_equipment: "Gerät",

      internal_device_name: "Interner Gerätename",

      product_backup: "Produktdaten Backup",

      page_not_found: "Seite nicht gefunden",
      invalid_creds: "Ungültige Anmeldeinformationen",

      Uhrzeit: "Uhrzeit",

      area_delete: "Bereich löschen",

      sideNav_quality_management: "Qualitätsmanagement",
      sideNav_manual_reports: "Manuelle Reports",
      sideNav_geplante_reports: "Geplante Reports",

      sideNav_maintenance: "Instandhaltung",
      sideNav_maintenance_calender: "Wartungskalender",
      sideNav_works_and_devices: "Werke und Geräte",
      sideNav_product_backup: "Produktdaten Backup",

      sideNav_equipments: "Equipments",

      equipment_scope_description:
        "Ihr Equipment sind Ihre Mesutronic Geräte, die Sie in MesuLink verwalten möchten.",

      single_document: "Dokument",
      status: "Status",
      send: "Schicken",
      eemail: "Email",

      maintenance_progress_title1: "Aktuelle Schaltzyklen",
      maintenance_progress_title1_1: "Laufzeit des Förderbandes (Minuten)",
      maintenance_progress_title2: "Bis Wartung vs. Kritisch",

      share_via_email: "per e-mail teilen",
      share_email_btn: "JETZT SENDEN",

      email_validation_error: "Bitte geben Sie eine gültige Email Adresse an",
      delete_photo: "Foto löschen",
      upload_new_photo: "Neues Bild hochladen",
      landlinenummer: "Festnetznummer",

      single_area: "Bereich",
      charge: "Aufladung",

      product_number: "Produkt-Numme",
      item_device_name: "Artikel Gerätename",

      time_nkt: "Zeitpunkt",

      password_validation_error:
        "Das aktuelle Passwort ist falsch. (mindestens 8 Zeichen, ein Großbuchstabe und ein Kleinbuchstabe sind Pflicht)",

      two_fector_desc:
        "Bitte geben Sie den sechsstelligen Code aus Ihrer Google Authenticator App ein.",

      enter_code: "Code eingeben",

      monats: "monats",
      overdue: "Überfällig",
      feasible: "Durchführbar",

      carried_out: "Durchgeführt",
      selected_devices: "Geräte ausgewählt",

      time_period: "Zeitraum",
      start_time: "Startzeit",
      end_time: "Endzeit",
      product_count: "Produktanzahl",
      dash_stats_tooltip:
        "Anzahl Ausscheidungen (ohne Test) in 8 Stunden Produktionszeit im Vergleich zu durchschnittlichen Anzahl Ausscheidungen in 8 Stunden (selbes Produkt)",

      last: "letzte",
      reject_detection: "Ausscheidungen",
      detector_test: "Erfolgreich abgeschlossene Detektortests",
      dashboard_proportion: "Anteil Ausscheidungen am Gesamtvolumen",

      no_data: "Keine Daten",
      cloud_backups: "In der Cloud gespeicherte Backups",
      sort_desc: "absteigend sortiert",
      sort_asec: "aufsteigend sortiert",
      actions: "Aktionen",
      backup: "Backup",
      assign_equipment: "Equipment zuordnen",

      single_site: "Werk",
      all_backups: "alle Backups",
      alle_machine_parks: "Alle Machineparks",

      all: "Alle",
      category: "Kategorie",
      optional: "Optional",
      short_description: "Kurzbeschreibung",
      display_name: "Anzeigename",
      upload_attachment_title: "Datei auswähle",

      undefined: "Undefined",
      enter_search_term: "Suchbegriff...",

      profile: "Profil",

      header_search: "Suchen nach Kunden, Geräte, …",

      maintenance_dashboard_kpi_1_title1: "Geräte fehlerbedingt",
      maintenance_dashboard_kpi_1_title2: " außer Betrieb (Live)",

      maintenance_dashboard_kpi_2_title1: "Störungsmeldung (mesuLINK)",
      maintenance_dashboard_kpi_2_title2: "",

      maintenance_dashboard_kpi_3_title1: "Störungsfreier Betrieb",
      maintenance_dashboard_kpi_3_title2: "",

      create_report: "Meldung erstellen",
      reload_page: "Seite neuladen",
      browser_doesnot_support: "Ihr Browser unterstützt die Video-Task nicht.",

      are_you_sure_to_delete: "Möchten Sie wirklich löschen?",
      delete_confirmation: "Bestätigung löschen",
      answer: "Antwort",
      machine_detail: "Maschinendetail",

      dashboard_scope_header: "Dashboard",
      dashboard_scope_header_desc:
        "Auf dem Dashboard erhalten Sie einen Überblick über den Status Ihrer Geräte und aktuelle Meldungen in Ihrem Werk.",

      miantenance_calender_title: "Geplante Wartungen",
      maintenance_calender_scope_header_desc:
        "Diese Ansicht hilft Ihnen dabei, wiederkehrende Wartungen und Inspektionen im Blick zu behalten und einzuplanen.",

      miantenance_calender_select_1_label: "Maschinenpark / Abschnitt",
      miantenance_calender_select_2_label: "Durchführungsstatus",

      scope_new_rp_desc:
        "Halten Sie Meldungen und Geschehnisse in Ihren Werken mittels geplanter Reports fest und exportieren Sie die Daten als PDF/CSV.",

      scope_new_mn_rp_desc:
        "Erstellen Sie vorgefertige Reports auf Knopfdruck und exportieren Sie so einfach Daten über Meldungen und Ereignisse als PDF/CSV.",

      attach_log_file: "Geräte-Log-Datei an diese Meldung anhängen",

      diagnose_information: "Diagnoseinformationen",
      diagnose_information_description:
        "Um Probleme effektiv zu identifizieren, benötigen wir die Diagnoseinformationen Ihres Geräts",
      create_title_helper_text: "z.B.: “Hauptspindel defekt”",
      applicable_device: "Betreffendes Gerät",
      reported: "Gemeldet",

      message_description: "Beschreibung der Meldung",
      share_notification: "Benachrichtigung teilen",

      write_mail: "Bitte geben Sie eine E-Mail-Adresse ein",
      next_appointment: "Nächster Termin",

      next_report: "Nächster Report",

      save_maintenance_task: "Wartung erstellen",
      desc_planned_aintenance: "Beschreibung der geplanten Wartung",

      create_noti_desc_title: "Beschreibung der Meldung",

      create_maintenance_task: "Neue geplante Wartung erstellen",
      create_maintenance_desc:
        "Alle für eine Maschine registrierten User erhalten eine Erinnerung zur Ausführung der Wartung. Sie können die registrierten Maschinen über das Profil der Nutzer verwalten.",

      faq_description:
        "Hier finden Sie häufige Fragen und Antworten zu diesem Gerät und können eigene Fragen und Antworten dokumentieren.",
      empty_state_faq_heading: "Häufige Fragen und Antworten",
      empty_state_faq_title: "Sie haben noch keine FAQs hinterlegt",
      empty_state_faq_description:
        "Klicken Sie auf den Button, um eine neue neue Frage und Antwort zu dieser Maschine zu hinterlegen.",

      empty_state_maintenance_heading: "Routinewartungen",
      empty_state_maintenance_title: "Sie haben noch keine Wartungen geplant",
      empty_state_maintenance_description:
        "Routinewartungen werden in regelmäßigen Intervallen ausgeführt.",

      empty_state_history_title: "Gerätehistorie",
      empty_state_history_heading:
        "Für dieses Gerät wurden noch keine Meldungen registriert",
      empty_state_history_subheading:
        "Hier finden Sie alle Störungen, Wartungen, Notizen, etc., die jemals für dieses Gerät im System dokumentiert worden sind.",
      tab_docs_manual: "Bedienungsanleitungen",
      tab_messages_mo: "Meldungen",
      search_word: "Suchwort",
      password: "Passwort",
      export_pdf: "PDF Exportieren",
      filter_export: "Filter & Export",
      deviceHistory: "Gerätehistorie",
      all_devices: "alle Geräte",
      current_reports: "Aktuelle Meldungen und geplante Wartungen",
      tab_device_messages: "Gerätemeldungen",
      more_stores: "weitere Laden",
      your_devices: "Ihre Geräte",
      device_type: "Produkt/Artikel",
      receivers_email: "E-Mail des Empfängers",
      backup_toast_text:
        "Backup wurde erstellt und in Mesutronic Cloud gespeichert.",
      backup_data_upload_loader: "Produktdaten-Backup wird erstellt",
      backup_reload_tooltip: "Backup einspielen",
      backup_download_tooltip: "Backup downloaden",
      backup_delete_tooltip: "Backup löschen",
      set_password:"Password festlegen",
      backup_upload_tooltip: "Manuelles Backup in Cloud hochladen",
      descending: "absteigend",
      ascending: "aufsteigend",
      backup_title_1: "Backup von Produktparametern",
      backup_title_2: "Ihre Geräte",
      backup_scope_description:
        "Hier können Sie für Ihre Geräte Backups von Produktparametern erstellen und wieder einspielen.",
      backup_search_placeholder: "Gerät suchen...",
      sites: "Werke",
      areas: "Bereiche",
      request_email: "E-Mail anfordern",
      assign_new_password: "neues Passwort vergeben",
      new_password_detail:
        "Ihr Passwort muss mindestens 8 Zeichen lang sein und einen Groß- sowie einen Kleinbuchstaben enthalten.",
        register_now:"Sie können sich jetzt anmelden.",
      new_password_title: "Neues Passwort vergeben",
      back_to_login: "Zurück zum Login",
      reset_password: "Passwort zurücksetzen",
      reset_password_detail:
        "Sie erhalten eine E-Mail zum Zurücksetzen Ihres Passworts.",

      check_code: "Code überprüfen",
      atleast_one_option: "Wählen Sie mindestens eine Option aus",
      new: "Neu",
      upload: "Upload",
      report_edit: "Report bearbeiten",

      emptm_state_report_detail_title: "Es wurden noch keine Reports erstellt.",
      emptm_state_report_detail_description:
        "Sie können die Planung dieses Reports jederzeit bearbeiten.",
      rows_per_page: " Einträge pro Seite",
      new_report_title_1: "Neuer Report",

      new_report_title_2_select_1_label: "Werke",
      new_report_title_2_select_2_label: "Bereiche",
      new_report_title_2_select_3_label: "Geräte",

      new_report_title_3_select_1_label: "Zyklus",
      new_report_title_3_select_2_label: "Tag",
      new_report_title_3_select_3_label: "Uhrzeit",

      new_report_title_4_select_1_label: "Export eines Reports pro",

      new_report_input_placeholder: "Titel des Reports",
      new_report_input_subheader_1: "z.B.: “Täglicher Report für alle Geräte“",
      new_report_title_2: "Auswahlkriterien",
      time_based: "Zeit-basiert",
      new_report_title_3: "Erstellungszeitpunkt",
      new_report_title_4: "Ausgabeeinstellungen",
      new_report_footer_label: "Nächster Report: %s Uhr",
      new_report_footer_button: "report erstellen",
      new_report_checkbox_label: "Report automatisch per E-Mail senden",
      new_report_input_subheader_2:
        "Für jedes Werk wird ein gesonderter Report-Datensatz erstellt.",
      new_report_input_subheader_2_site:
        "Für jedes Werk wird ein gesonderter Report erstellt.",
      new_report_input_subheader_2_area:
        "Für jeden Bereich wird ein gesonderter Report erstellt.",
      new_report_input_subheader_2_equipment:
        "Für jedes Gerät wird ein gesonderter Report erstellt.",
      new_report_input_subheader_2_all:
        "Alle Werke, Bereiche und Geräte werden in einem Report zusammengefasst.",
      scope_new_report_desc:
        "Mittels feingranularer Auswahlmöglichkeiten legen Sie fest, welche Werke, Bereiche oder Geräte Ihre späteren Reports umfassen.",
      scope_new_report_plan: "Neuen Report planen",
      scope_edit_report_plan: "Reportplan bearbeiten",
      service_sticker: "Service-Sticker",
      interner: "Interner:",
      reportsTitle: "Geplante Reports",
      manual: "manuell",
      manualReportsTitle: "Manuelle Reports",
      onlyMyReports: "nur meine Reports anzeigen",
      reportsEmptyStateTitle: "Sie haben noch keine Reports geplant",
      manualReportsEmptyStateTitle:
        "Sie haben noch keine manuellen Reports konfiguriert",

      manualReportsEmptystateDescription:
        "Konfigurieren Sie jetzt Ihren ersten manuellen Report, um später per Knopfdruck einfach Reports erstellen zu können.",

      reportsEmptyStateBtn: "neuen Report Planen",
      manualReportsEmptyStateBtn: "Neuer Report",
      reportsEmptystateDescription:
        "Planen Sie jetzt Ihren ersten Report, um die Meldungen Ihrer Geräte langfrisitg im dokumentieren zu können.",
      login_header: "mesuLINK Login",
      empty_dashboard_button: "Profil & einstellungen Öffnen",
      empty_dashboard_title: "Sie haben noch keine Maschinen abonniert",
      empty_docs_title: "Sie haben noch keine Dateien hochgeladen",
      empty_docs_desc:
        "Laden Sie eine Datei hoch und ordnen Sie diese einer Kategorie zu.Tipp: Sie können Dateien auch per Drag and Drop hochladen.",
      empty_dashboard_desc:
        "Um Maschinen zu abonnieren müssen Sie in Ihrem Userprofil im Bereich , Ihre Maschinen die für Sie relevanten Werke oder Maschinen Pools auswählen.",
      footer_contact: "Kontakt",
      footer_data_protection: "Datenschutz",
      footer_impressum: "Impressum",
      equipment_serial_number: "Seriennummer",
      counter_Type: "Zählertyp",
      export_machine_details: "Export Ihrer Daten",
      no_notifications:
        "Keine neuen Benachrichtigungen. Wir benachrichtigen Sie, sobald es neue Vorfälle gibt.",
      add_new_counter: "NEU",

      tab_counters: "ZÄHLER",
      streetnumber: "Straße",
      postalCode: "Postleitzahl",
      city: "Stadt",
      land: "Land",
      firmName: "Firm Name",
      homePage: "Startseite",
      firm_details: "DETAILS ZU IHRER FIRMA",
      email: "E-Mail-Adresse",
      forgot_password: "Passwort vergessen?",
      noti_title_helpertext: "z.B.: “Ausscheideeinheit defekt“",
      loginHeading: "Login",
      loginButton: "Einloggen",
      registration: "Registrieren",
      no_account: "SIE HABEN NOCH KEINEN ACCOUNT?",
      required_field: "Pflichtfeld",
      register_for_free: "Kostenfrei registrieren",
      searchplaceholder_tablet: "Suchen nach Maschinen, Meldungen, …",
      searchplaceholder_phone: "Suchen nach Maschinen, Meldungen, …",
      createnewissue: "Neue Meldung erstellen",
      update_notification: "Meldung Bearbeiten",
      opennotifications: "Offene Meldungen",
      machineparks: "Maschinenparks",
      machinepark: "Maschinenpark",
      all_machineparks: "Alle Maschinenparks",
      factorysections: "Werksabschnitte",
      machinecategory: "Maschinenkategorie",
      machinestatus: "Maschinenstatus",
      groupby: "Gruppieren nach",
      timerange: "Zeitraum",
      show_n_more: "%s weitere anzeigen",
      show_more: "weitere anzeigen",
      show_less: "Weniger anzeigen",
      empty_notifications: "derzeit keine",
      notification_singular: "Meldung",
      notification_plural: "Meldungen",
      dashboard_messages: "Meldungen",
      avg_solutiontime: "MTTR",
      incidents: "Störfälle",
      statistics: "Statistiken",
      overall_statistics: "Gesamtstatistik",
      set_password_btn:"PASSWORT ERZEUGEN",
      new_notification: "Neue Meldung",
      create_new_notification: "Neue Meldung erstellen",
      create_notification: "Meldung erstellen",

      save_notification: "Speichern",
      save: "Speichern",
      filter_sorting: "Filter & Sortierung",
      filter: "Filter",
      sorting: "Sortierung",
      unresolved: "ungelöst",
      day: "Tag",
      days: "Tage",
      empty_machineparks:
        "Es sind noch keine Maschinenparks eingerichtet worden. Wenden Sie sich bitte an den Administrator.",
      undisturbed: "störungsfrei",
      disturbed: "Störung",
      tab_dashboard: "Dashboard",
      tab_machineparks: "Maschinenparks",
      tab_messages: "Nachrichten",
      super_tab_clients: "Kunden",
      super_tab_users: "Benutzer",
      user: "Benutzer",
      super_tab_brands: "Marken",
      super_tab_equipment_types: "Gerätetypen",
      tab_notifications: "Mitteilungen",
      manufacturer_serial_number: "Hersteller-Seriennummer",
      add_nameplate_photo: "Typenschild-Foto hinzufügen",
      heading_latest_notifications: "Aktuelle Meldungen & geplante Wartungen",
      go_to_machine_history: "Zur Maschinenhistorie",
      heading_responsible: "Verantwortlich",
      heading_manufacturer_service: "Hersteller-Service",
      heading_life_cycle: "Lebenslauf",
      notificationtype: "Meldungstyp",
      built_year: "Baujahr",
      empty_history:
        "Die Maschinenhistorie weißt bisher noch keine Meldungen auf.",
      today: "Heute",
      heading_documentation: "Dokumentation",
      heading_docs: "Dokumentation",
      file_powerpoint: "PowerPoint",
      file_excel: "Excel",
      file_word: "Word",
      file_email: "Email",
      file_word_macro: "Word (Macro)",
      file_odt: "ODT Dokument",
      file_ods: "ODS Spreadsheet",
      file_image: "Bild",
      file_audio: "Audio",
      file_video: "Video",
      file_url: "Link",
      hasinternalattachment: "Interne Ressourcen",
      hasmanufacturerattchment: "Hersteller Ressourcen",
      add_new_resource: "neue Ressource hinzufügen",
      add_ressource: "Ressource hinzufügen",
      upload_file: "Datei hochladen",
      resource_vendor: "Zuordnung",
      resource_type: "Typ",
      resource_type_file: "Datei",
      resource_type_link: "Link",
      resource_type_photo: "Foto",
      resource_type_video: "Video",
      resource_url: "Link (URL)",
      change_file: "Datei ändern",
      resource_name: "Titel der Ressource",
      resource_description: "Beschreibung (optional)",
      resource_language: "Sprache",
      resource_scope: "Gültigkeitsbereich",
      button_cancel: "abbrechen",
      button_yes: "Ja",
      button_no: "Nein",
      empty_resources:
        "Bisher wurden dieser Maschine noch keine Ressourcen hinzugefügt.",
      button_done: "Fertig",
      select_multiple_n: "mehrere (%s)",
      header_data: "Kopfdaten",
      referred_to_machine: "Betreffende Maschine",
      notification_title: "Titel der Meldung",
      helpertext_notification_title: 'z. B.: "Hauptspindel defekt"',
      referred_to_assembly: "Betroffene Baugruppe",
      date: "Datum",
      time: "Zeit",
      problem_solution_status: "Status der Problemlösung",
      notification_description: "Beschreibung der",
      describe_notification: "Beschreiben Sie die Meldung…",
      add_photos_videos: "Fotos/Videos hinzufügen",
      capture_photo: "Neues Foto aufnehmen",
      capture_video: "Neues Video aufnehmen",
      add_from_gallery: "Von Galerie hinzufügen",
      add_attachments: "Anhänge hinzufügen",
      enter_description: "Beschreibung eingeben…",
      change_attachments: "Anhänge ändern",
      notification_sucessfully_created: "Die Meldung wurde erfolgreich erfasst",
      discuss_notification: "Meldung besprechen",
      go_to_machine: "zur Maschine",
      notificationtype_from: "%notificationtype vom %datetime",
      reported_by: "Gemeldet durch",
      machine: "Maschine",
      images: "Bilder",
      no_images_yet: "Dieser Meldung wurden noch keine Bilder hinzugefügt.",
      attachments: "Anhänge",
      edit_notification: "Meldung bearbeiten",
      notification_solved: "Die Meldung wurde erfolgreich gelöst.",
      close_notification_heading: "Meldung schließen",
      close_notification_text:
        "Möchten Sie die Meldung als gelöst kennzeichen und alle Beteiligten Instanzen darüber informieren?",
      settings: "Einstellungen",
      chat_notifications: "Chat-Benachrichtigungen",
      automatic_translation: "Automatische Übersetzung",
      activate: "aktivieren",
      target_language: "Zielsprache",
      involved_contacts_heading: "Beteiligte Kontakte",
      search_contacts: "Kontakte suchen…",
      empty_discussion_contacts:
        "Dieser Diskussion wurden noch keine Kontakte hinzugefügt.",
      discussion_heading: "Diskussion",
      error_chatroom_loading: "Der Chatraum konnte nicht geladen werden.",
      error_email_required: "Bitte E-Mail-Adresse eingeben",
      error_email_format: "Eingegebene E-Mail-Adresse ist ungültig",
      error_password_required: "Bitte Passwort eingeben",
      error_password_wrong: "E-Mail und Passwort stimmen nicht überein.",
      enter_message: "Nachricht eingeben…",
      time_h: "Uhr",
      alert_trash_changes_body:
        "Möchten Sie die von Ihnen vorgenommenen Änderungen verwerfen?",
      button_save_changes: "Änderungen speichern",
      logout: "Ausloggen",
      all_notificationtypes: "alle Meldungstypen",
      notificationtype_malfunction: "Störungen",
      notificationtype_abnormality: "Auffälligkeit",
      notificationtype_memo: "Notizen",
      notificationtype_task: "Aufgabe",
      notificationtype_internal_message: "Interne Mitteilungen",
      notificationtype_manufacturer_message: "Herstellermitteilung",
      notificationtype_planned_maintenance: "Geplante Wartungen",
      notificationtype_maintenance: "Wartungen",
      avg_uptime: "Uptime",
      search_result: { sng: "Suchergebnis", plr: "Suchergebnisse" },
      documents: "Dokumente",
      machines: "Maschinen",
      messages: "Nachrichten",
      all_categories: "alle Kategorien",
      profile_settings: "Profil & Einstellungen",
      add_machine_photo: "Maschinenfoto hinzufügen",
      add_machine_typenameplate_photo: "Typenschild der Maschine",
      add_user_photo: "Benutzerbild hinzufügen",
      state_open: "offen",
      state_closed: "erledigt",
      state_in_discussion: "in Bearbeitung",
      loading: "Wird geladen",
      access_denied: "Zugriff verwehrt!",
      week: "Woche",
      month: "Monat",
      add_new_user: "Neuen Benutzer hinzufügen",
      first_name: "Vorname",
      last_name: "Nachname",
      user_list: "Benutzerliste",
      please_fill_name: "Bitte vergeben Sie einen Namen.",
      backLink: "Zurück",
      create_new_area: "Neuen Bereich anlegen",
      area_name: "Werksabschnittsname",
      area_id: "ID des Werksabschnitts",
      e_g_area_1: "z. B. Werk 1",
      e_g_area_id: "z. B. 1233",
      button_create_area: "Abschnitt erstellen",
      manage_machine_parks: "Maschinenparks verwalten",
      manage_machine_park: "Maschinenpark verwalten",
      create_machine: "Maschine anlegen",
      manufacturer_name: "Herstellerbezeichnung",
      e_g_casing_machining: "z. B. Gehäusebearbeitung",
      internal_id: "Identifikationsnummer",
      e_g_internal_id: "z. B. 5214",
      invetory_id: "Inventar ID",
      e_g_inventory_id: "z. B. 1234",
      memo_field: "Notizen",
      button_create_machine: "Maschine anlegen",
      create_equipment_pool: "Maschinenpark anlegen",
      equipment_pool_name: "Name des Maschinenparks",
      equipment_pool_id: "ID des Maschinenparks",
      e_g_equipment_pool_id: "z. B. 1234",
      button_create_equipment_pool: "Maschinenpark anlegen",
      create_new_site: "Neues Werk anlegen",
      site_name: "Name des Werkes",
      e_g_site_name: "z. B. Werk 1",
      e_g_city: "z. B. Ingolstadt",
      site_zip: "Postleitzahl des Werkes",
      e_g_site_zip: "z. B. 85053",
      street: "Straße",
      e_g_street: "z. B. Münchner Straße",
      house_number: "Hausnummer",
      e_g_house_number: "z. B. 8",
      site_id: "ID des Werkes",
      e_g_site_id: "z. B. 1234",
      button_create_site: "Werk anlegen",
      button_update_site: "Werk speichern",

      statistics_since_initial_operation: "Statistik seit Inbetriebnahme",
      manufacturer_website: "Hersteller-Webseite",
      click_or_dragdrop: "Klicken oder Drag-and-Drop",
      download: "Download",
      page: "Seite",
      ofPage: "von",
      previous: "Zurück",
      next: "Weiter",
      file_title: "Dateititel",
      file_description: "Beschreibung",
      upload_internal_file: "Interne Datei hochladen",
      show_qr_code: "QR-Code anzeigen",
      confirm_password: "Passwort bestätigen",
      show_type_plate: "Typenschild anzeigen",
      type_plate: "Typenschild",
      show_more_info: "mehr Infos anzeigen",
      more_filter_sorting: "mehr Filter & Sortierung",
      button_create_equipment: "Equipment erstellen",
      creating_equipment: "Ausrüstung erstellen",
      typing: "schreibt…",
      write_a_message: "Schreiben Sie eine Nachricht…",
      role: "Rolle",
      phone_number_mobile: "Handynummer (optional)",
      phone_number_landline: "Festnetz",
      info_notification_status:
        "Sie erhalten automatisch Statusupdates für die für Sie zugewiesenen Maschinen.",
      your_machines: "Ihre Maschinen",
      min_n_characters: "Mindestens 8 Zeichen",
      button_create_account: "Account erstellen",
      load_older_notifications: "ältere laden",
      tab_sites: "Werke",
      tab_admin: "Adminbereich",
      area: "Bereiche",
      area_heading: "Werksabschnitt",
      open_menu: "Menü öffnen",
      corporate_email: "Unternehmens-E-Mail-Adresse",
      //create client labels
      create_client_name: "Kundenname",
      create_client_billinginformation: "Abrechnungsdaten",
      create_client_licenseinformation: "Lizenzinformationen",
      create_client_legalentityname: "Offizielle Unternehmensbezeichnung",
      create_client_domain: "Domain",
      create_client_address: "Adresse",
      tab_overview: "Übersicht",
      tab_discussion: "Diskussion",
      heading_photos: "Fotos",
      heading_videos: "Videos",
      button_upload_photo: "Foto hochladen",
      button_upload_video: "Video hochladen",
      button_upload_attachment: "Anhang hochladen",
      image_here: "Bild hier",
      none_uploaded: "Keine hochgeladen",
      empty_discussion: "Bisher wurde diese Meldung noch nicht diskutiert.",
      tab_history: "Historie",
      tab_documentation: "Dokumentation",
      tab_faq: "FAQ",
      tab_maintenance: "Wartungen",
      till_now: "Bis jetzt",
      create_site: "Werk erstellen",
      create_area: "Werksabschnitt erstellen",
      all_sites: "alle Werke",
      manufacturer: "Hersteller",
      internal_machine_name: "Interner Maschinenname (optional)",
      heading_your_profile: "Ihr Profil",
      heading_safety: "Sicherheit",
      photo: "Foto",
      add_solution: "Lösung Hinzufügen",
      workflow_step_desc: "Beschreibung",
      save_solution: "Lösung Speichern",
      workflow_title: "Workflow-Titel",
      no_workflow_title: "Kein Titel",
      notification_solutions: "Vorgehensbeschreibung",
      none_solution: "Keine Lösung",
      edit_solution: "Lösung Bearbeiten",
      internal_faqs: "Intern FAQs",
      manufacturer_faqs: "Hersteller FAQs",
      update_faq: "BEARBEITEN",
      clear_faq: "LÖESCHEN",
      add_new_faq: "neue FAQ",
      add_faq: "FAQ hinzufügen",
      edit_faq: "FAQ bearbeiten",
      faq_question: "Frage",
      faq_answer: "Anwort",
      save_FAQ: "FAQ speichern",
      maintenance: "Routinewartungen",
      new_maintenance: "Neue Wartung",
      history_title: "Maschinenhistorie",
      history_description:
        "Hier finden Sie alle Störungen, Wartungen, Notizen, etc., die jemals für diese Maschine im System dokumentiert worden sind.",
      maintenance_desc:
        "Routinewartungen werden in regelmäßigen Intervallen ausgeführt.",
      counter_desc:
        "Zähler helfen Ihnen dabei,  wichtige Kennzahlen wie zum Beispiel Betriebsstunden zu registrieren und im Blick zu behalten.",
      new_maintenance_create: "Neue Wartung erstellen",
      maintenance_title: "Titel der Wartung",
      maintenance_title_helperText: "z.B.: “Große Inspektion”",
      maintenance_category: "Kategorie der Wartung",
      maintenance_category_manage: "Kategorien verwalten",
      maintenance_category_manage_title: "Wartungs-Kategorien verwalten",
      maintenance_category_new_title: "Neue Kategorie anlegen",
      maintenance_category_title: "Name der Kategorie",
      maintenance_category_title_helperText: "z.B.: “ISO “45001",
      maintenance_category_btn_save: "Kategorie anlegen",
      maintenance_category_delete: "Kategorie löschen",
      maintenance_category_edit: "Kategorie editieren",
      maintenance_date: "Erster Termin",
      maintenance_repetition: "Turnus der Wiederholung",
      maintenance_reminder: "Erinnerung vor Termin",
      maintenance_description: "Beschreibung der Wartungen",
      maintenance_create_btn: "Wartungen erstellen",
      maintenance_update_btn: "SPEICHERN",
      maintenance_repetition_yearly: "jährlich",
      maintenance_repetition_month: "Monat",
      maintenance_repetition_week: "Woche",
      maintenance_reminder_days: "Tage",
      maintenance_repetition_once: "Einmalig",
      maintenance_repetition_months: "Monate",
      maintenance_reminder_Week: "Woche",
      maintenance_reminder_Weeks: "Wochen",
      maintenance_reminder_month: "Monat",
      maintenance_next_termine: "nächster Termin",
      maintenance_report: "Protokoll",
      maintenance_report_empty: "Es wurde noch kein Protokoll erstellt.",
      maintenance_report_add_btn: "Protokoll erstellen",
      protocol_executed: "Ausführungsdatum",
      protocol_title: "Bericht Erstellen",
      protocol_comments: "Bemerkungen",
      protocol_title_pretext: "Durchgeführt am",
      protocol_title_posttext: "von",
      protocol_description: "Zusammenfassung",
      protocol_update: "Bearbeiten Protokoll",
      menu_Instandhaltung: "Instandhaltung",
      menu_Instandhaltung_submenu: "Meldungen",
      menu_Instandhaltung_submenu1: "Geplante Wartungen",

      no_maintenancetask: "Keine Wartungsaufgabe verfügbar",
      edit_equipment: "Speichern",
      edit: "bearbeiten",
      delete: "Löschen",
      nav_machinetype: "Maschinentypen",
      nav_customermachines: "Kundenmaschinen",
      nav_customermachines_allmachine: "Alle Maschinen",
      nav_customermachines_analysis: "Analyse",
      nav_servicemanagement: "Servicemanagement",
      nav_administration: "Administration",
      all_brands: "Alle Marken",
      brand: "Marken",
      create_equipment_type: "Create MachinenTypen",
      update_equipment_type: "Update MachinenTypen",
      delete_equipment_type: "Delete MachinenTypen",
      create_brand: "Create Brand",
      update_brand: "Update Brand",
      delete_brand: "Delete Brand",
      create_equipment_class: "Create Equipment Class",
      update_equipment_class: "Update Equipment Class",
      delete_equipment_class: "Delete Equipment Class",
      customer_equipments: "Kundenmaschinen",
      customer_contact: "Kundenkontakt",

      history_filter_created: "Erstellt",
      history_filter_closed: "abgeschlossen",
      history_filter_type: "Typ",
      history_filter_status: "Status",
      history_filter_keyword: "Stichwort",
      history_filter_reset: "zurücksetzen",
      history_filter_export: "Auswahl exportieren",
      history_filter_actions: "Aktionen",
      systemCreated: "System Created",
      allMachines: "Alle Maschinen",
      allMachinePools: "Alle Maschinenparks",
      allSites: "Alle Werke",
      no_open_notification: "keine offen meldung",
      new_area: "neuer Bereich ",
      create_an_area: "bereich anlegen",
      create_area_helper_text: "z.B.: Gehäusefertigung",

      manualReportsSelectOptions: {
        lastBatch: { label: "Letzte Charge", value: "lastBatch" },
        currentBatch: { label: "Laufende Charge", value: "currentBatch" },
        currentd: { label: "Gestern", value: "currentd" },
        last7d: {
          label: "Letzte 7 Tage (default)",
          value: "last7d",
        },
        last14d: { label: "Letzte 14 Tage", value: "last14d" },
        last30d: { label: "Letzte 30 Tage", value: "last30d" },
        currentw: {
          label: "Diese Woche (Montag bis heute)",
          value: "currentw",
        },
        last1w: {
          label: "Letzte Woche (Montag bis Sonntag)",
          value: "last1w",
        },
        currentm: { label: "Dieser Monat", value: "currentm" },
        last1m: { label: "Letzter Monat", value: "last1m" },
        last3m: { label: "Letzte 3 Monate", value: "last3m" },
        last6m: { label: "Letzte 6 Monate", value: "last6m" },
        currenty: { label: "Dieses Jahr", value: "currenty" },
        last1y: { label: "Letztes Jahr", value: "last1y" },
        customInterval: {
          label: "Benutzerdefiniert (einmaliger Report)",
          value: "customInterval",
        },
      },
    },
  };

  return {
    ...localizedStrings[language],
    language, // Include the formatDate function in the returned object
  };
}

export default i18n;
